import {Routes, Route} from 'react-router-dom'
// Pages générales
import Home from "./Pages/Home/Home";
import About from './Pages/About/About';
import Machines from './Pages/Machines/Machines';
import Cours from './Pages/Cours/Cours';
import Docs from './Pages/Docs/Docs';
import Hardware from './Pages/Hardware/Hardware';
import Maj from './Pages/MAJ/Maj';
//COURS
import Introduction from './Pages/Cours/Articles/introduction';
import CoursLaRam from './Pages/Cours/Articles/laRam';
import RamVideo from './Pages/Cours/Articles/ramVideo';
import Adressage from './Pages/Cours/Articles/adressage';
import Commandes from './Pages/Cours/Articles/commandes';
import Border from './Pages/Cours/Articles/border';
import CouleursActives from './Pages/Cours/Articles/couleursActives';
import ModeGraphiques from './Pages/Cours/Articles/modesGraphiquesGeneralite';
import ModeChange from './Pages/Cours/Articles/changementMode';
import Caracteres from './Pages/Cours/Articles/caracteres';
import CaractereEcran from './Pages/Cours/Articles/envoiCaractereEcran';
//DOCS
import CaracteresG0 from './Pages/Docs/ArticlesDoc/JeuG0';
import CaracteresG10 from './Pages/Docs/ArticlesDoc/jeuG10'
import CaracteresG11 from './Pages/Docs/ArticlesDoc/jeuG11';
//DIVERS
import EnConstruction from './Pages/EnConstruction/EnConstruction';

//----------------------------------------------------------------------------------------------------------
export default function RoutesList()
    {
        return(
            <Routes>
                <Route path="/About" element={<About/>} />
                <Route path="/" element={<Home/>} />
                <Route path="/Machines" element={<Machines/>} />
                <Route path="/Cours" element={<Cours/>} />
                <Route path="/Docs" element={<Docs/>} />
                <Route path="/Hardware" element={<Hardware/>} />
                <Route path="/Maj" element={<Maj/>} />
                {/*COURS*/}
                <Route path="/Introduction" element={<Introduction/>} />
                <Route path="/CoursLaRam" element={<CoursLaRam/>} />
                <Route path="/RamVideo" element={<RamVideo/>} />
                <Route path="/Adressage" element={<Adressage/>} />
                <Route path="/Commandes" element={<Commandes/>} />
                <Route path="/Border" element={<Border/>} />
                <Route path="/CouleursActives" element={<CouleursActives/>} />
                <Route path="/ModeGraphiques" element={<ModeGraphiques/>} />
                <Route path="/ModeChange" element={<ModeChange/>} />
                <Route path="/Caracteres" element={<Caracteres/>} />
                <Route path="/CaractereEcran" element={<CaractereEcran/>} />
                {/*DOCS*/}
                <Route path="/CaracteresG0" element={<CaracteresG0/>} />
                <Route path="/CaracteresG10" element={<CaracteresG10/>} />
                <Route path="/CaracteresG11" element={<CaracteresG11/>} />
                {/*DIVERS*/}
                <Route path="/EnConstruction" element={<EnConstruction/>} />
                {/* <Route path="*" element={<P404/>} />         */}
            </Routes>
        )
    }